import React from "react"
import {BankLogoProps, defaultBankLogoSize} from "../../images/bankLogos/bankLogoUtils"

const defaultFill = "#F4F5F7"
const defaultSize = defaultBankLogoSize

interface BankNameAndLogoProps {
	name: string
	logo?: (props: BankLogoProps) => JSX.Element
	size?: number
	fill?: string
	className?: string
}
export function BankNameAndLogo({
	name,
	logo: Logo,
	size = defaultSize,
	fill = defaultFill,
	className,
}: BankNameAndLogoProps) {
	if (!name) {
		return null
	}

	return (
		<>
			{Logo && <Logo size={size} fill={fill} className="mr-2" />}
			<p className={className ? className : "box-title font-14 font-bold"}>{name}</p>
		</>
	)
}
